import localforage from 'localforage';


export const HttpCache = {
  isActive: true,
  async get(key) {
    if (this.isActive) {
      const data = await localforage.getItem(key);
      return data;
    }
  },
  async save(key, data) {
    if (this.isActive) {
      await localforage.setItem(key, data);
    }
  }
};
